/* PR-2 #5: Extracted from main-product.liquid (was inline media-gallery slider init).
   Loaded via defer to keep parser unblocked. Pure JS — no Liquid templating. */
  (() => {
    const mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery) return;

    // Match CSS even while mobile layout/scroll overflow changes innerWidth during load.
    const phoneViewport = window.matchMedia('(max-width: 749px)');
    const desktopSlider = mediaGallery.querySelector('.product__media-list--desktop');
    const mobileSlider = mediaGallery.querySelector('.product__media-list--mobile');
    const defaultSlider = mediaGallery.querySelector('.product__media-list:not(.product__media-list--desktop):not(.product__media-list--mobile)');

    const getActiveSlider = () => {
      const isMobile = phoneViewport.matches;
      if (mobileSlider && isMobile) return mobileSlider;
      if (desktopSlider && !isMobile) return desktopSlider;
      if (defaultSlider) return defaultSlider;
      return null;
    };

    const thumbnailsSlider = mediaGallery.querySelector('[id^="GalleryThumbnails"]');

    const svgNext = `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <path d="M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z" stroke="#ECEBDE"/>
      <path d="M17.5 26.6668L24.1667 20.0002L17.5 13.3335" stroke="#727270" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

    const svgPrev = `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" style="transform: rotate(180deg);">
      <path d="M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z" stroke="#ECEBDE"/>
      <path d="M17.5 26.6668L24.1667 20.0002L17.5 13.3335" stroke="#727270" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

    const prev = document.createElement('button');
    const next = document.createElement('button');
    prev.className = 'pdp-main-arrow pdp-main-arrow--prev lpl-edge-tab lpl-edge-tab--prev';
    next.className = 'pdp-main-arrow pdp-main-arrow--next lpl-edge-tab lpl-edge-tab--next';
    prev.type = 'button';
    next.type = 'button';
    prev.setAttribute('aria-label', mediaGallery.querySelector('button[name="previous"]')?.getAttribute('aria-label') || 'Previous image');
    next.setAttribute('aria-label', mediaGallery.querySelector('button[name="next"]')?.getAttribute('aria-label') || 'Next image');
    prev.innerHTML = svgPrev;
    next.innerHTML = svgNext;

    // Anchor the arrows to the <slider-component> that's currently visible.
    // In metafield mode, there are TWO slider-components (one for desktop,
    // one for mobile) — the inactive one is display:none, so anchoring to
    // the wrong one makes the arrows disappear. We pick dynamically and
    // re-place on resize.
    const placeArrows = () => {
      const slider = getActiveSlider();
      const target =
        (slider && slider.closest('slider-component')) ||
        mediaGallery.querySelector('slider-component:not(.thumbnail-slider)') ||
        mediaGallery.querySelector('slider-component') ||
        mediaGallery;
      if (prev.parentElement !== target) target.appendChild(prev);
      if (next.parentElement !== target) target.appendChild(next);
    };
    placeArrows();

    const getThumbnailItems = () => {
      if (!thumbnailsSlider) return [];
      return Array.from(thumbnailsSlider.querySelectorAll('.thumbnail-list__item'));
    };

    const getActiveIndex = (items) => items.findIndex((item) => item.querySelector('button')?.getAttribute('aria-current') === 'true');

    const getCurrentIndex = (slider) => {
      if (!slider) return 0;
      const slides = Array.from(slider.querySelectorAll('.product__media-item'));
      if (slides.length === 0) return 0;

      const scrollLeft = slider.scrollLeft;

      // Mobile-style horizontal scroll-snap: derive index from scrollLeft / slideWidth.
      // This is reliable across Dawn's default / metafield / thumbnail slider modes —
      // unlike the previous offsetLeft loop, which produced wonky values depending on
      // the slide's offset parent and led to both arrows being hidden on mobile.
      const sampleSlide = slides[0];
      const slideWidth = sampleSlide && sampleSlide.clientWidth ? sampleSlide.clientWidth : 0;
      if (slideWidth > 0) {
        const idx = Math.round(scrollLeft / slideWidth);
        return Math.min(slides.length - 1, Math.max(0, idx));
      }

      // Fallback: original offsetLeft scan
      let currentIndex = 0;
      for (let i = 0; i < slides.length; i++) {
        const slideLeft = slides[i].offsetLeft;
        if (scrollLeft >= slideLeft - 50) currentIndex = i;
        else break;
      }
      return currentIndex;
    };

    const getTotalSlides = (slider) => {
      if (!slider) return 0;
      return slider.querySelectorAll('.product__media-item').length;
    };

    const scrollToSlide = (slider, direction) => {
      if (!slider) return;
      const slides = Array.from(slider.querySelectorAll('.product__media-item'));
      if (slides.length === 0) return;
      const currentIndex = getCurrentIndex(slider);
      let targetIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;
      if (targetIndex < 0) targetIndex = 0;
      if (targetIndex >= slides.length) targetIndex = slides.length - 1;
      const targetSlide = slides[targetIndex];
      if (targetSlide) {
        slider.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
      }
    };

    const setArrowState = (button, unavailable) => {
      const ariaDisabled = String(unavailable);
      const opacity = unavailable ? '0' : '1';
      const pointerEvents = unavailable ? 'none' : 'auto';
      if (button.disabled !== unavailable) button.disabled = unavailable;
      if (button.getAttribute('aria-disabled') !== ariaDisabled) button.setAttribute('aria-disabled', ariaDisabled);
      if (button.style.opacity !== opacity) button.style.opacity = opacity;
      if (button.style.pointerEvents !== pointerEvents) button.style.pointerEvents = pointerEvents;
    };

    // Scroll, media updates and layout changes can arrive in the same frame.
    // Read gallery geometry once and only write arrow states when they change.
    let arrowFrame = 0;
    const scheduleArrowUpdate = () => {
      if (arrowFrame) return;
      arrowFrame = requestAnimationFrame(() => {
        arrowFrame = 0;
        if (mediaGallery.isConnected) updateArrowStates();
      });
    };

    const updateArrowStates = () => {
      const isMobile = phoneViewport.matches;
      const activeSlider = getActiveSlider();

      if (!isMobile && thumbnailsSlider && getThumbnailItems().length > 0) {
        const items = getThumbnailItems();
        if (!items.length) {
          setArrowState(prev, true);
          setArrowState(next, true);
          return;
        }
        const current = getActiveIndex(items);
        setArrowState(prev, current <= 0);
        setArrowState(next, current >= items.length - 1);
      } else if (activeSlider) {
        const totalSlides = getTotalSlides(activeSlider);
        const currentIndex = getCurrentIndex(activeSlider);
        setArrowState(prev, currentIndex <= 0);
        setArrowState(next, currentIndex >= totalSlides - 1);
      } else {
        setArrowState(prev, true);
        setArrowState(next, true);
      }
    };

    prev.addEventListener('click', () => {
      const isMobile = phoneViewport.matches;
      const activeSlider = getActiveSlider();
      if (!isMobile && thumbnailsSlider && getThumbnailItems().length > 0) {
        const items = getThumbnailItems();
        if (!items.length) return;
        const current = getActiveIndex(items);
        const target = current - 1;
        if (target < 0) return;
        items[target].querySelector('button')?.click();
        setTimeout(scheduleArrowUpdate, 100);
      } else if (activeSlider) {
        scrollToSlide(activeSlider, 'prev');
        setTimeout(scheduleArrowUpdate, 200);
      }
    });

    next.addEventListener('click', () => {
      const isMobile = phoneViewport.matches;
      const activeSlider = getActiveSlider();
      if (!isMobile && thumbnailsSlider && getThumbnailItems().length > 0) {
        const items = getThumbnailItems();
        if (!items.length) return;
        const current = getActiveIndex(items);
        const target = current + 1;
        if (target >= items.length) return;
        items[target].querySelector('button')?.click();
        setTimeout(scheduleArrowUpdate, 100);
      } else if (activeSlider) {
        scrollToSlide(activeSlider, 'next');
        setTimeout(scheduleArrowUpdate, 200);
      }
    });

    if (thumbnailsSlider) {
      thumbnailsSlider.querySelectorAll('.thumbnail-list__item button').forEach((btn) => {
        btn.addEventListener('click', () => setTimeout(scheduleArrowUpdate, 100));
      });
    }

    const watchSliderScroll = () => {
      const activeSlider = getActiveSlider();
      if (activeSlider && !activeSlider._scrollListenerAdded) {
        activeSlider.addEventListener('scroll', scheduleArrowUpdate, { passive: true });
        activeSlider._scrollListenerAdded = true;
      }
    };

    const observer = new MutationObserver(() => {
      watchSliderScroll();
      scheduleArrowUpdate();
    });
    observer.observe(mediaGallery, { childList: true, subtree: true });

    let resizeTimer = 0;
    window.addEventListener('resize', () => {
      // Re-place arrows on viewport change — the active slider-component
      // may switch between the desktop and mobile variants in metafield mode.
      placeArrows();
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(scheduleArrowUpdate, 100);
    }, { passive: true });

    setTimeout(() => {
      watchSliderScroll();
      scheduleArrowUpdate();
    }, 100);
  })();
